import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import { forword, aatcReviewComment } from "../../actions/studensts";
import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import { useState } from "react";
import { useLocation } from "react-router-dom";

export default function ActionButtonsAatcReview() {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loadingHold, setLoadingHold] = useState(false);
  const [loadingReturn, setLoadingReturn] = useState(false);

  const { id } = useParams();
  const location = useLocation();
  const element = location.state;

  const username = JSON.parse(localStorage.getItem("profile"))?.value[0].username;

  // Comment state
  const [comment, setComment] = useState(element?.aatc_review || "");
  const [commentInput, setCommentInput] = useState(element?.aatc_review || "");
  const [commentLoading, setCommentLoading] = useState(false);
  const [commentError, setCommentError] = useState("");

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoadingHold(false);
      setLoadingReturn(false);
    }, 2000);
  }

  const handleForwardDeliveryHold = async () => {
    setLoadingHold(true);
    const res = await forword(id, "moe/", "delivery_hold", username);
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  const handleReturnMoePending = async () => {
    setLoadingReturn(true);
    const res = await forword(id, "moe/", "moe_pending", username);
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  const handleSaveComment = async () => {
    if (!commentInput) {
      setCommentError("Can't save without a comment");
      return;
    }
    setCommentLoading(true);
    setCommentError("");
    const res = await aatcReviewComment(id, commentInput, username);
    setCommentLoading(false);
    if (res.status === 200) {
      setComment(commentInput);
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setCommentError(res?.data?.ERROR || "Failed to save comment");
    }
  };

  return (
    <>
      <div className="py-3 text-center">
        {showSuccessAlert && <AlertSuccess text={text} />}
        {showDengerAlert && <AlertDenger text={text} />}

        {/* AATC Review Comment Section */}
        <div className="p-3 mb-3 border rounded bg-blue-50 text-left">
          <h3 className="font-bold text-blue-800 mb-2">AATC Review Comment</h3>
          {comment && (
            <p className="text-sm mb-2">
              <span className="font-semibold">Current Comment:</span> {comment}
            </p>
          )}
          <textarea
            className="w-full border rounded p-2 text-sm"
            rows={3}
            value={commentInput}
            onChange={(e) => setCommentInput(e.target.value)}
            placeholder="Enter AATC Review comment..."
          />
          {commentError && (
            <p className="text-red-600 text-xs mt-1">{commentError}</p>
          )}
          <div className="mt-2">
            <Button
              color="bg-blue-600 disabled:bg-gray-300"
              onClick={handleSaveComment}
              disabled={commentLoading}
              text={!commentLoading ? "Save Comment" : <Loading />}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap justify-between mt-2">
          <div className="p-2">
            <Button
              color="bg-gray-600 disabled:bg-gray-300"
              onClick={handleReturnMoePending}
              disabled={loadingReturn}
              text={!loadingReturn ? "Return to MOE Pending" : <Loading />}
            />
          </div>
          <div className="p-2">
            <Button
              color="bg-yellow-600 disabled:bg-gray-300"
              onClick={handleForwardDeliveryHold}
              disabled={loadingHold}
              text={!loadingHold ? "Forward to Delivery Hold" : <Loading />}
            />
          </div>
        </div>
      </div>
    </>
  );
}
